<template>
    <div>
        <div class="position-relative row">
            <div class="col-12 col-sm-5">
                <span v-if="!is_mobile">Foundri ID: {{ vehicle.display_id }}<br/></span>
                <span v-if="!is_mobile">VIN: {{ vehicle.vin }}<br/></span>
                <template v-if="vehicle.vehicle_make">
                    Make: {{ vehicle.vehicle_make.name }}<br/>
                </template>
                Model: {{ vehicle.vehicle_model.name }}<br/>
            </div>
            <div class="col-12 col-sm-5">
                <template v-if="vehicle.company && !is_mobile">
                    Dealer: {{ vehicle.company.name }}<br/>
                </template>
                Price: {{ vehicle.price | currency }}
                <span style="font-size: 11px; margin-top: -6px;">
                    (Dealer may add additional fees)
                </span>
                <br/>
                Status:
                <i :class="[vehicleStatusClass]" class="mdi mdi-checkbox-blank-circle"/> {{ vehicleStatusLabel }}<br/>
            </div>
            <div
                class="back-btn d-flex justify-content-end align-items-sm-start col-sm-2"
                >
                <button
                    class="btn border p-1"
                    @click="back()"
                    style="cursor: pointer"
                >
                    <ArrowRightBottomIcon />
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-5">
                <div v-if="vehicle.status !== VehicleStatus.sold.value">
                    <b-link :to="{name: Routes.view_vehicle, params: {id : vehicle.id}}" class="btn btn-primary waves-effect waves-light mt-2 d-block d-sm-inline-block"
                            v-if="showViewButton">
                        <i class="mdi mdi-car-back"></i> View Vehicle
                    </b-link>
                </div>
            </div>
            <div class="col-12 col-sm-7">
                <div v-if="vehicle.status !== VehicleStatus.sold.value">
                    <button @click="viewContactDetails"
                            class="contact-details-btn btn btn-dark mt-2"
                            type="button">
                        <ContactDetailsIcon class="pr-1" />
                        {{ contactDetailsLabel }} Contact Details
                    </button>
                </div>
            </div>
        </div>
        <contact-details-modal
            v-if="vehicle"
            ref="contactDetailsModal"
            :company="getCompany"
            :enquiry-handlers="enquiry_handlers"
            :is-seller="isSeller"
        />
    </div>
</template>

<script>
import ContactDetailsModal from "@/components/main/company/ContactDetailsModal";
import ContactDetailsIcon from "@/components/main/icons/ContactDetailsIcon";
import ArrowRightBottomIcon from "@/components/main/icons/ArrowRightBottomIcon";
import Routes from "@/constants/routes";
import vehicle_mixin from "@/mixins/vehicle";
import VehicleStatus from "@/constants/vehicle-statuses";

export default {
    mixins: [vehicle_mixin],
    components: {
        ArrowRightBottomIcon,
        ContactDetailsIcon,
        ContactDetailsModal,
    },
    props: {
        deal: {
            required: true,
            type: Object,
        },
        showViewButton: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        vehicle() {
            return this.deal.vehicle;
        },
        isSeller() {
            return this.$store.state.user.companies[0].id === this.vehicle.company_id;
        },
        getCompany() {
            if (this.isSeller) {
                return this.deal.buyer.companies[0];
            }

            return this.deal.seller.companies[0];
        },
        contactDetailsLabel() {
            return this.isSeller ? 'Buyer\'s' : 'Seller\'s';
        },
    },
    data() {
        return {
            Routes,
            VehicleStatus,
            enquiry_handlers: [],
        }
    },
    created() {
        this.initEnquiryHandlers();
    },
    methods: {
        viewContactDetails() {
            this.$refs.contactDetailsModal.show();
        },
        back() {
            history.back()
        },
        initEnquiryHandlers() {
            return axios.post('/web-api/user/dealer-enquiry-handler?include=roles', {
                    company_id: this.getCompany?.id,
                })
                .then((response) => {
                    this.enquiry_handlers = response.data;
                })
        },
    },
}
</script>

<style scoped>
.back-btn {
    position: static;
}

@media (max-width: 575.98px) {
    .contact-details-btn {
        width: 100%;
    }
    .back-btn {
        position: absolute;
    }
}
</style>
